import { TokenPayload } from '../types/auth.types';
import { env } from '@/config/env';

const TOKEN_KEY = env.tokenStorageKey;
const REFRESH_TOKEN_KEY = env.refreshTokenStorageKey;

export const tokenService = {
  getToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
  },

  setToken: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  getRefreshToken: (): string | null => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  setRefreshToken: (refreshToken: string): void => {
    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }
  },

  removeTokens: (): void => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  isTokenExpired: (token?: string): boolean => {
    const currentToken = token || tokenService.getToken();
    if (!currentToken) return true;

    try {
      const payload = tokenService.decodeToken(currentToken);
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch {
      return true;
    }
  },

  decodeToken: (token: string): TokenPayload => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
    return JSON.parse(jsonPayload);
  },

  getTokenPayload: (): TokenPayload | null => {
    const token = tokenService.getToken();
    if (!token || tokenService.isTokenExpired(token)) {
      return null;
    }
    return tokenService.decodeToken(token);
  }
};
